import { Button, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
import { toast, ToastContainer } from "react-toastify";
import actions from "../../../ReduxStore/actions";
import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";

const UsersSync = () => {

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("Settings"));
        dispatch(setSubHeaderName("Users Sync"));
    }, [dispatch]);

    const [loading, setLoading] = useState(false)
    const handleSubmit = async () => {


        setLoading(true)
        const data1 = {
            data: {},
            method: "get",
            apiName: `MicrosoftUsersync`
        };
        const responseData = await dispatch(actions.MICROSOFTUSERSSYNC(data1));
        console.log(responseData, "responseData")
        const message = responseData?.payload?.message;

        // const pattern = /^Found\s+\d+\s+PDF\(s\)\s+under\s+appraisal_year\s+'(\d{4}-\d{2})'\.?$/;

        const text = message;
        const pattern = /^Synced\s+(\d+)\s+users\s+from\s+Microsoft\s+365\. and guest user (\d+)$/;

        const match = text?.match(pattern);
        console.log(match,"match")
        // if (pattern.test(message)) {
        //     const match = message.match(pattern);
        //     console.log(match, "matchhhh")
        //     const appraisalYear = match[1]; // e.g., "2029-30"
        //     console.log("✅ Valid message with appraisal year:", appraisalYear);

        // } else {
        //     console.log("❌ Invalid message format.");
        // }
        // const match = message.match(pattern);


        if (responseData?.payload?.message === match[0]) {
            // setLoading(false)
            // setEditData(responseData?.payload?.data)
            console.log("hiiiii")
            // setOpenDialog(true);

            // if (responseData?.payload?.message === "Synced 40 users from Microsoft 365. and guest user 0") {
            setLoading(false)
            toast.success(responseData?.payload?.message)
            // }
        }

        else {
            setLoading(false)

            toast.error(responseData?.payload?.message)
        }


    }
    return (
        <Box sx={{ background: "white", px: 3, py: 3 }}>
            {loading && <FullPageLoader />}
            {/* <Typography variant="h5" gutterBottom sx={{ color: "black" }}> */}
            <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>

                Users Sync
            </Typography>

            <Button
                variant='contained'
                sx={{ mt: 3, background: 'var(--main-color)', textTransform: "none",mb:2 }}
                onClick={() => {
                    handleSubmit()
                }}
            >
                Users Sync
            </Button>
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />

        </Box>


    )
}
export default UsersSync